import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { RegisterSystemUserRequest } from './registration.types';

import { requestRegisterSystemUser } from './registration.actions';

export const useRegistrationApi = () => {
  const dispatch = useDispatch();

  const registerSystemUser = useCallback(
    (requestData: RegisterSystemUserRequest, onSuccess?: (programmeName: string) => void) => {
      dispatch(requestRegisterSystemUser({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { registerSystemUser };
};
